export default {
    items: [
        {
            value: 'C',
            path: '/hri/request/leaveofabsence',
            headText: 'ลาหยุด',
            description: '',
            icon: 'schedule',
            color: '#C73659',
            roleView: [true, false],
            statusOpen: 'on',
            styleBackgroung: '',
            adFRole: ['staff', 'faculty']
        },
        {
            value: 'D',
            path: '/hri/request/otrequest',
            headText: 'ทำงานล่วงเวลา [ OT ]',
            description: 'ตามประกาศจาก งานทรัพยากรบุคคลวิทยาลัยนานาชาติ',
            icon: 'clock-circle',
            color: '#4D869C',
            roleView: [true, false],
            statusOpen: 'on',
            styleBackgroung: '',
            adFRole: ['staff']
        },
        {
            value: 'A',
            path: '/hri/request/flexible',
            headText: 'Flexible Day',
            description: '',
            icon: 'swap',
            color: '#68B984',
            roleView: [false],
            statusOpen: 'on',
            styleBackgroung: '',
            adFRole: ['staff']
        },
        {
            value: 'F',
            path: '/hri/request/seminar',
            headText: 'อบรม / สัมมนา <br> ประชุม / ดูงาน',
            description: '',
            icon: 'reconciliation',
            color: '#9C9EFE',
            roleView: [false],
            statusOpen: 'on',
            styleBackgroung: '',
            adFRole: ['staff']
        },
        // {
        //     value: 'F',
        //     path: '/hri/request/travelAbroad',
        //     headText: 'เดินทางไปต่างประเทศของบุคลากร',
        //     description: '',
        //     icon: 'file-protect',
        //     color: '#7469B6',
        //     roleView: [false],
        //     statusOpen: 'on',
        //     styleBackgroung: '',
        {
            value: 'Z',
            path: '/hri/request/absentTime',
            headText: 'บันทึกเวลาปฏิบัติงาน',
            description: '',
            icon: 'issues-close',
            color: '#FF884B',
            roleView: [false],
            statusOpen: 'on',
            styleBackgroung: '',
            // 'staff'
            adFRole: ['staff']
        },
        // {
        //     value: 'H',
        //     path: '/hri/request/hrdbudget',
        //     headText: 'HRD Budget Report',
        //     description: '',
        //     icon: 'file-protect',
        //     color: '#456882',
        //     roleView: [false],
        //     statusOpen: 'on',
        //     styleBackgroung: '',
        //     adFRole: ['staff']
        // },
        {
            value: 'B',
            path: '/hri/request/workfromhome',
            headText: 'Work from Home',
            description: '',
            icon: 'home',
            color: '#E67E22',
            roleView: [false],
            statusOpen: 'on',
            styleBackgroung: '',
            adFRole: ['staff']
        }
    ]
}
